module.exports = [
  { name: 'id' },
  { name: 'name' },
  { name: 'content', localized: true }
]
